/** Nav / sidebar item with optional integration id (AppFeatureIntegrations.IntegrationKey). */
export type NavItemWithFeature = {
  integrationKey?: string
  children?: NavItemWithFeature[]
}

/** Hides items whose integration is disabled; drops empty parent groups. Missing integration = show. */
export function filterNavItemsByAppFeatures<T extends NavItemWithFeature>(
  items: T[],
  isIntegrationEnabled: (integrationKey: string) => boolean,
): T[] {
  return items
    .map(item => {
      if (item.children?.length) {
        const children = filterNavItemsByAppFeatures(item.children, isIntegrationEnabled)
        if (children.length === 0) {
          return null
        }
        return { ...item, children }
      }
      if (item.integrationKey && !isIntegrationEnabled(item.integrationKey)) {
        return null
      }
      return item
    })
    .filter((item): item is T => item != null)
}
